import React, { useContext } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { Context } from "../context";
import classes from "./CloudPlayerDemo.module.css";

const CloudPlayerDemo = () => {
  const navigate = useNavigate();
  const { lang } = useContext(Context);

  const titleText = "Cloud Player Demo";
  const descText = lang === "it"
    ? "Simulazione ed esecuzione del Cloud Player all'interno di un dispositivo mobile."
    : "Simulation and execution of the Cloud Player inside a mobile device.";

  return (
    <>
      <title>Davide Balice - Cloud Player Demo</title>
      <motion.div
        className={classes.container}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
      >
        <button className={classes.backBtn} onClick={() => navigate("/")}>
          <FaArrowLeft />
          Home
        </button>

        <h1 className={classes.title}>{titleText}</h1>
        <p className={classes.subtitle}>{descText}</p>

        {/* Smartphone Mockup */}
        <div className={classes.phoneFrame}>
          <iframe
            src="http://cloud-player.webdemo.cloud/"
            title="Cloud Player Demo"
            className={classes.iframe}
          />
        </div>
      </motion.div>
    </>
  );
};

export default CloudPlayerDemo;
